import React from 'react';
import Typography from '@mui/material/Typography';
import {useLocalization} from 'localization';
import {Card} from 'components/card';

export const ThemaCategoryGuide: React.FC = () => {
  const {t} = useLocalization();

  return (
    <Card background={'beige'} level={'level2'}>
      <Card.Header>
        <Typography variant="h3" color={'primary'}>
          {t('text.thema.rule.header')}
        </Typography>
      </Card.Header>
      <Card.Content>
        <Card background={'beige'} level={'level3'}>
          <Card.Content>
            <Typography variant={'body2'} component={'div'}>
              <ol className={'themaRules'}>
                <li>{t('text.thema.rule.first')}</li>
                <li>{t('text.thema.rule.second')}</li>
                <li>{t('text.thema.rule.third')}</li>
                <li>{t('text.thema.rule.fourth')}</li>
                <li>{t('text.thema.rule.fifth')}</li>
                <li>{t('text.thema.rule.sixth')}</li>
              </ol>
            </Typography>
          </Card.Content>
        </Card>
      </Card.Content>
    </Card>
  );
};
